var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-4"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Timeline')))])]),_c('div',{staticClass:"mt-2"},[_c('LogsTimeline',{attrs:{"items":_vm.items},on:{"submit":_vm.onCommentSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }